/**
 * Maps React Router path patterns to i18n keys for document metadata.
 * Keys reference `meta.admin.pages.*` in the shared i18n translations.
 */
export interface PageMetaEntry {
  titleKey: string;
  descriptionKey: string;
}

export const PAGE_META_MAP: Array<{ pattern: string; meta: PageMetaEntry }> = [
  // Auth
  {
    pattern: "/login",
    meta: {
      titleKey: "meta.admin.pages.login.title",
      descriptionKey: "meta.admin.pages.login.description",
    },
  },
  {
    pattern: "/forgot-password",
    meta: {
      titleKey: "meta.admin.pages.forgotPassword.title",
      descriptionKey: "meta.admin.pages.forgotPassword.description",
    },
  },

  // Catalog — match detail before list
  {
    pattern: "/catalog/services/:serviceId",
    meta: {
      titleKey: "meta.admin.pages.catalogServiceDetail.title",
      descriptionKey: "meta.admin.pages.catalogServiceDetail.description",
    },
  },
  {
    pattern: "/catalog/services",
    meta: {
      titleKey: "meta.admin.pages.catalogServices.title",
      descriptionKey: "meta.admin.pages.catalogServices.description",
    },
  },
  {
    pattern: "/catalog/delivery-time-slots",
    meta: {
      titleKey: "meta.admin.pages.deliveryTimeSlots.title",
      descriptionKey: "meta.admin.pages.deliveryTimeSlots.description",
    },
  },

  // Portal pages
  {
    pattern: "/approvals",
    meta: {
      titleKey: "meta.admin.pages.approvals.title",
      descriptionKey: "meta.admin.pages.approvals.description",
    },
  },
  {
    pattern: "/orders/requests/:customerRequestId",
    meta: {
      titleKey: "meta.admin.pages.customerRequestDetail.title",
      descriptionKey: "meta.admin.pages.customerRequestDetail.description",
    },
  },
  {
    pattern: "/orders",
    meta: {
      titleKey: "meta.admin.pages.orders.title",
      descriptionKey: "meta.admin.pages.orders.description",
    },
  },
  {
    pattern: "/work-orders/:workOrderId",
    meta: {
      titleKey: "meta.admin.pages.workOrderDetail.title",
      descriptionKey: "meta.admin.pages.workOrderDetail.description",
    },
  },
  {
    pattern: "/work-orders",
    meta: {
      titleKey: "meta.admin.pages.workOrders.title",
      descriptionKey: "meta.admin.pages.workOrders.description",
    },
  },
  {
    pattern: "/vendors",
    meta: {
      titleKey: "meta.admin.pages.vendors.title",
      descriptionKey: "meta.admin.pages.vendors.description",
    },
  },
  {
    pattern: "/users",
    meta: {
      titleKey: "meta.admin.pages.users.title",
      descriptionKey: "meta.admin.pages.users.description",
    },
  },
  {
    pattern: "/geography",
    meta: {
      titleKey: "meta.admin.pages.geography.title",
      descriptionKey: "meta.admin.pages.geography.description",
    },
  },
  {
    pattern: "/vendor-services/listing",
    meta: {
      titleKey: "meta.admin.pages.vendorServiceListing.title",
      descriptionKey: "meta.admin.pages.vendorServiceListing.description",
    },
  },
  {
    pattern: "/config",
    meta: {
      titleKey: "meta.admin.pages.config.title",
      descriptionKey: "meta.admin.pages.config.description",
    },
  },
  {
    pattern: "/activity/audit",
    meta: {
      titleKey: "meta.admin.pages.activityAudit.title",
      descriptionKey: "meta.admin.pages.activityAudit.description",
    },
  },
  {
    pattern: "/activity/actions",
    meta: {
      titleKey: "meta.admin.pages.activityActions.title",
      descriptionKey: "meta.admin.pages.activityActions.description",
    },
  },
  {
    pattern: "/activity/errors",
    meta: {
      titleKey: "meta.admin.pages.activityErrors.title",
      descriptionKey: "meta.admin.pages.activityErrors.description",
    },
  },
  {
    pattern: "/users/security-events",
    meta: {
      titleKey: "meta.admin.pages.auditLog.title",
      descriptionKey: "meta.admin.pages.auditLog.description",
    },
  },
  {
    pattern: "/audit-log",
    meta: {
      titleKey: "meta.admin.pages.activityAudit.title",
      descriptionKey: "meta.admin.pages.activityAudit.description",
    },
  },
  {
    pattern: "/",
    meta: {
      titleKey: "meta.admin.pages.dashboard.title",
      descriptionKey: "meta.admin.pages.dashboard.description",
    },
  },
];

export const SITE_NAME_KEY = "meta.admin.siteName";
export const DEFAULT_DESCRIPTION_KEY = "meta.admin.defaultDescription";
